var React = require('react');

function HamburgerMenu (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 9H23","stroke":"#111111","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M1 1H23","stroke":"#111111","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M1 17H23","stroke":"#111111","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

HamburgerMenu.defaultProps = {"width":"24","height":"18","viewBox":"0 0 24 18","fill":"none"};

module.exports = HamburgerMenu;

HamburgerMenu.default = HamburgerMenu;
